import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WithPermissions } from 'react-admin';

import Menu from './Menu';

class MenuWithPermissions extends Component {
  render() {
    const { pathname } = this.props as any;
    return (
      <WithPermissions
        render={({ permissions }: any) => {
          return <Menu permissions={permissions} {...this.props} />;
        }}
        authParams={pathname}
      />
    );
  }
}

export default connect((state: any) => ({ pathname: state.router.location.pathname }))(
  MenuWithPermissions
);
